import type { Duration } from 'dayjs/plugin/duration'

/**
 * Port of cdc-web `helpers/formatExpiryCountdown.ts`（1:1）：recurring 副标题
 * 的到期倒计时格式——`"1d 2h"` / `"3h 45m"` / `"35m 20s"` / `"42s"`。
 */
export function formatExpiryCountdown(duration: Duration): string {
  const days = Math.floor(duration.asDays())
  const hours = duration.hours()
  const minutes = duration.minutes()
  const seconds = duration.seconds()

  if (days >= 1) {
    return hours > 0 ? `${days}d ${hours}h` : `${days}d`
  }
  if (hours >= 1) {
    return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`
  }
  if (minutes >= 1) {
    return seconds > 0 ? `${minutes}m ${seconds}s` : `${minutes}m`
  }
  return `${seconds}s`
}
